import React, { useMemo } from "react";
import { FlexboxGrid, Stack, Text } from "rsuite";
import { useSelector } from "react-redux";
import { selectConfigExpressRegistrationMultiplePermitsPerAPNPolicy, selectConfigExpressRegistrationTypeVerbiage, selectConfigExpressParcelVerbiage } from "../../store/slices/config/configSelectors";
import { titleize } from "../../common/utils";
import { MULTIPLE_PERMITS_PER_APN_POLICY_OPTIONS_ENUM } from "../../common/enums";
import Notice from "../user-feedback/Notice";

const GenericApplyWarning = ({ message, isAdmin = false }) => {
    const selectedPermitTypeVerbiage = useSelector(selectConfigExpressRegistrationTypeVerbiage);
    const multipleLicenseStatus = useSelector(selectConfigExpressRegistrationMultiplePermitsPerAPNPolicy);
    const parcelVarbiage = useSelector(selectConfigExpressParcelVerbiage);

    const noticeType = useMemo(() => {
        if (multipleLicenseStatus === MULTIPLE_PERMITS_PER_APN_POLICY_OPTIONS_ENUM.WARN) {
            return 'warning';
        }
        else {
            return 'error';
        }
    }, [multipleLicenseStatus, selectedPermitTypeVerbiage]);

    return (
        <FlexboxGrid>
            <FlexboxGrid.Item colspan={24}>
                <Notice type={noticeType} message={message} />
            </FlexboxGrid.Item>
        </FlexboxGrid>
    )
}

export default GenericApplyWarning;